import React, { useState } from 'react';
import { toast } from 'react-toastify';

function TeamAccountInfoModal({ show, onClose, teamData, loading }) { // 👈 props تغییر کرد
  const [copiedField, setCopiedField] = useState(null);

  const copyToClipboard = async (text, fieldName) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedField(fieldName);
      setTimeout(() => setCopiedField(null), 2000);
    } catch (err) {
      console.error('خطا در کپی:', err);
    }
  };

  if (!show) return null;

  // حالت loading
  if (loading) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose}></div>
        <div className="relative bg-gradient-to-br from-slate-900 to-slate-800 rounded-2xl p-8">
          <div className="flex flex-col items-center gap-4">
            <div className="animate-spin w-12 h-12 border-4 border-teal-500 border-t-transparent rounded-full"></div>
            <p className="text-white text-sm">در حال دریافت اطلاعات...</p>
          </div>
        </div>
      </div>
    );
  }

  // اگر data نباشه یا خالی باشه
  if (!teamData || !teamData.team || !teamData.team.accounts || teamData.team.accounts.length === 0) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose}></div>
        <div className="relative bg-gradient-to-br from-slate-900 to-slate-800 rounded-2xl p-8 max-w-md w-full">
          <p className="text-white text-center mb-4">حساب تیم یافت نشد</p>
          <button onClick={onClose} className="w-full px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-xl transition">
            بستن
          </button>
        </div>
      </div>
    );
  }

  const account = teamData.team.accounts[0];
  const isCaptain = teamData.is_captain;

const accountData = [
  { label: 'Login', value: account.login.toString(), key: 'login' },
  { label: 'Balance', value: `$${parseFloat(account.score || 0).toLocaleString()}`, key: 'Balance' },
  { label: 'Equity', value: `$${parseFloat(account.equity || 0).toLocaleString()}`, key: 'equity' },
  { label: 'Type', value: account.type === 'demo' ? 'Demo' : 'Real', key: 'type' },
  ...(isCaptain
    ? [{ label: 'Password', value: account.password, key: 'password' }]
    : [{ label: 'Investor', value: account.investor, key: 'investor' }]
  )
];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" style={{ direction: 'rtl' }}>
      <div 
        className="absolute inset-0 bg-black/70 backdrop-blur-sm"
        onClick={onClose}
      ></div>

      <div className="relative bg-gradient-to-br from-slate-900 via-teal-900/20 to-slate-900 rounded-xl sm:rounded-2xl shadow-2xl w-full max-w-5xl border border-teal-500/30 overflow-hidden flex flex-col" style={{ maxHeight: '90vh' }}>
        {/* Animated Background */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute w-64 sm:w-96 h-64 sm:h-96 bg-teal-500/10 rounded-full blur-3xl -top-20 -right-20 animate-pulse"></div>
          <div className="absolute w-64 sm:w-96 h-64 sm:h-96 bg-teal-600/10 rounded-full blur-3xl -bottom-20 -left-20 animate-pulse" style={{ animationDelay: '1s' }}></div>
        </div>

        {/* Header */}
        <div className="relative flex items-center justify-between p-4 sm:p-6 border-b border-slate-700 flex-shrink-0">
          <div className="flex items-center gap-2 sm:gap-3">
            <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-teal-500 to-teal-600 rounded-lg sm:rounded-xl flex items-center justify-center shadow-lg shadow-teal-500/50 flex-shrink-0">
              <svg className="w-5 h-5 sm:w-6 sm:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <div className="min-w-0">
              <h2 className="text-base sm:text-xl font-bold text-white truncate">اطلاعات حساب تیم</h2>
              <p className="text-xs sm:text-sm text-gray-400 truncate">{teamData.team.name} {isCaptain && '(کاپیتان)'}</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="w-9 h-9 sm:w-10 sm:h-10 rounded-lg sm:rounded-xl flex items-center justify-center hover:scale-105 transition bg-teal-500/20 border border-teal-500/30 flex-shrink-0"
          >
            <svg className="w-5 h-5 sm:w-6 sm:h-6 text-teal-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className="relative flex-1 overflow-y-auto p-4 sm:p-6">
          <div className="flex flex-col gap-3 sm:gap-4">
            {/* Status Badge */}
            <div className="flex items-center justify-between bg-slate-800/50 backdrop-blur-sm rounded-lg sm:rounded-xl p-3 sm:p-4 border border-slate-700">
              <div className="flex items-center gap-2 sm:gap-3">
                <div className={`w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full ${account.status === 0 ? 'bg-green-500' : 'bg-red-500'} animate-pulse`}></div>
                <span className="text-white font-semibold text-sm sm:text-base">وضعیت حساب</span>
              </div>
              <span className={`px-3 sm:px-4 py-1 sm:py-1.5 rounded-full text-xs sm:text-sm font-semibold ${
                account.status === 0
                  ? 'bg-green-500/20 text-green-400 border border-green-500/30' 
                  : 'bg-red-500/20 text-red-400 border border-red-500/30'
              }`}>
                {account.status === 0 ? 'فعال' : 'غیرفعال'}
              </span>
            </div>

            {/* Team Info */}
            <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg sm:rounded-xl p-3 sm:p-4 border border-slate-700">
              <div className="flex items-center gap-3">
                <div 
                  className="w-12 h-12 rounded-lg flex items-center justify-center text-white font-bold"
                  style={{ backgroundColor: teamData.team.color }}
                >
                  {teamData.team.name.substring(0, 2)}
                </div>
                <div>
                  <p className="text-white font-semibold text-sm sm:text-base">{teamData.team.name}</p>
                  <p className="text-gray-400 text-xs sm:text-sm">امتیاز تیم: {teamData.team.points}</p>
                </div>
              </div>
            </div>

            {/* Account Details */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-3">
              {accountData.map((item) => (
                <div key={item.key} className="bg-slate-800/50 backdrop-blur-sm rounded-lg sm:rounded-xl p-3 sm:p-4 border border-slate-700 hover:border-teal-500/30 transition-all">
                  <div className="flex items-center justify-between gap-2">
                    <div className="flex-1 min-w-0">
                      <p className="text-xs sm:text-sm text-gray-400 mb-0.5 sm:mb-1">{item.label}</p>
                      <p className="text-white font-semibold text-sm sm:text-base lg:text-lg truncate">{item.value}</p>
                    </div>
                    <button
                      onClick={() => copyToClipboard(item.value, item.key)}
                      className="flex-shrink-0 p-1.5 sm:p-2 rounded-lg bg-teal-500/20 hover:bg-teal-500/30 border border-teal-500/30 transition-all group"
                      title="کپی"
                    >
                      {copiedField === item.key ? (
                        <svg className="w-4 h-4 sm:w-5 sm:h-5 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                      ) : (
                        <svg className="w-4 h-4 sm:w-5 sm:h-5 text-teal-400 group-hover:text-teal-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                        </svg>
                      )}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="relative p-4 sm:p-6 border-t border-slate-700 flex-shrink-0">
          <button
            onClick={onClose}
            className="w-full px-4 sm:px-6 py-2.5 sm:py-3 bg-gradient-to-r from-teal-600 to-teal-700 hover:from-teal-700 hover:to-teal-800 text-white rounded-lg sm:rounded-xl font-semibold transition-all duration-200 shadow-lg shadow-teal-500/50 hover:shadow-teal-500/70 text-sm sm:text-base"
          >
            بستن
          </button>
        </div>
      </div>
    </div>
  );
}

export default TeamAccountInfoModal;